
export default {
  vessel: {
    title: {
      fontSize: '3xl',
      fontWeight: 'bold'
    }
  },
  async asyncData({ $content, app: { i18n: { locale }, $seoMeta } }) {
    const page = await $content(locale, 'pages/terms').fetch()
    $seoMeta.update($seoMeta.page(page.seo))

    return {
      page
    }
  }
}
